import React from 'react';

import { formatMoney, formatVolume, shortName } from './insulationPickerFormat.js';

/**
 * Самое дешёвое по каждому применению — первый пункт задания.
 *
 * Показывается, пока применение не выбрано: как только менеджер сузил фильтр,
 * ответ на вопрос «а что дешевле под эту задачу» даёт сама таблица.
 *
 * Свёрнута по умолчанию. Строк в ней под два десятка, и развёрнутой она
 * отодвигает саму таблицу за нижний край экрана — а нужна она не всегда, а
 * когда менеджер ещё не решил, с какого применения начинать. Заголовок при
 * этом виден всегда, иначе про сводку просто забудут.
 */
const InsulationPickerDigest = ({ items, isOpen = false, onToggle }) => {
  // Сколько применений вообще с чем сравнивать. Свёрнутая сводка иначе
  // выглядит как заголовок ни о чём: раскрывать её или нет — решают по этому
  // числу, а не по названию.
  const withOffers = items.filter((item) => item.cheapest).length;

  return (
  <div className={`ins-pick__digest${isOpen ? ' is-open' : ''}`}>
    <button
      type="button"
      className="ins-pick__digest-toggle"
      aria-expanded={isOpen}
      onClick={onToggle}
    >
      <span className="ins-pick__digest-title">Самое дешёвое по каждому применению</span>
      <span className="ins-pick__digest-count">
        {withOffers} из {items.length}
      </span>
      <span className="ins-pick__digest-chevron" aria-hidden="true">{isOpen ? '▲' : '▼'}</span>
    </button>

    {isOpen && (
    <ul className="ins-pick__digest-list">
      {items.map((item) => (
        <li key={item.key} className="ins-pick__digest-item">
          <span className="ins-pick__digest-label">{item.label}</span>
          {item.cheapest ? (
            <>
              <span className="ins-pick__digest-name">{shortName(item.cheapest.name)}</span>
              <span className="ins-pick__digest-price">
                {formatMoney(item.cheapest.pricePerM3)} ₽/м³
              </span>
              <span className="ins-pick__digest-volume">
                всего {formatVolume(item.totalVolume)} м³
              </span>
            </>
          ) : (
            // Товары под применение могут быть, а цен у них — нет: справочник
            // обнуляет цены старше 60 дней. Молчаливый прочерк рядом со
            // счётчиком «11 позиций» читался бы как ошибка.
            <span className="ins-pick__digest-none">
              {item.count > 0 ? `${item.count} поз. — нет актуальных цен` : 'нет товаров'}
            </span>
          )}
        </li>
      ))}
    </ul>
    )}
  </div>
  );
};

export default InsulationPickerDigest;
